import assetIcSustFabric from './ic-sust-fabric.svg';
import assetIcSustFactory from './ic-sust-factory.svg';
import assetIcSustFair from './ic-sust-fair.svg';
export enum SustainabilityIconName {
  SustainabilityFabric = 'SustainabilityFabric',
  SustainabilityFactory = 'SustainabilityFactory',
  SustainabilityFair = 'SustainabilityFair',
}

export const sustainabilityIconAssets: {
  [key in SustainabilityIconName]: string;
} = {
  [SustainabilityIconName.SustainabilityFabric]: assetIcSustFabric,
  [SustainabilityIconName.SustainabilityFactory]: assetIcSustFactory,
  [SustainabilityIconName.SustainabilityFair]: assetIcSustFair,
};
